// EN/FI interface translation. English is the default and fallback; Finnish
// is stored locally (no runtime translation). Only interface labels — never
// customer data, stored statuses or identifiers.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/i18n/locales/en.json";
import fi from "@/i18n/locales/fi.json";

export const SUPPORTED_LANGUAGES = ["en", "fi"];
export const LANG_CACHE_KEY = "miseone-lang";

export const normalizeLanguage = (v) => (SUPPORTED_LANGUAGES.includes(v) ? v : "en");

function cachedLanguage() {
    try { return normalizeLanguage(localStorage.getItem(LANG_CACHE_KEY)); } catch (_e) { return "en"; }
}

i18n.use(initReactI18next).init({
    resources: { en: { translation: en }, fi: { translation: fi } },
    lng: cachedLanguage(),
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
    returnEmptyString: false,
    react: { useSuspense: false },
});

export function applyLanguage(lang) {
    const next = normalizeLanguage(lang);
    try { localStorage.setItem(LANG_CACHE_KEY, next); } catch (_e) { /* private mode */ }
    if (i18n.language !== next) i18n.changeLanguage(next);
    if (typeof document !== "undefined") document.documentElement.lang = next;
    return next;
}

export default i18n;
